import React from 'react';
import { FormInputSelect } from '../../../common/formInputs/FormInputSelect';

const questions = {
  owner_contractor_relation: {
    label: 'Rapporto fra proprietario e contraente',
    name: 'owner_contractor_relation',
    options: [
      {
        id: 'Il contraente coincide con il proprietario',
        name: 'Il contraente coincide con il proprietario',
      },
      {
        id: 'Il contraente è il locatario del fabbricato',
        name: 'Il contraente è il locatario del fabbricato',
      },
    ],
  },
};

function CommercialCatastropheContractorRelations({
  errors,
  isValid,
  register,
}) {
  return (
    <>
      <h4 className="text-center mt-3">
        Rapporto fra proprietario e contraente
      </h4>
      <div className="row mt-5 d-flex justify-content-center">
        <div className="col-12 col-md-6 mb-4">
          <div className="card border">
            <div className="card-body">
              <div className="col-12">
                <div
                  className="d-flex flex-column align-items-center justify-content-center gap-5"
                  style={{ maxWidth: '600px' }}
                >
                  {Object.values(questions).map((question, index) => (
                    <FormInputSelect
                      placeholder="-Seleziona-"
                      key={index}
                      label={question.label}
                      options={question.options}
                      name={question.name}
                      error={errors?.relations?.[question.name]?.message}
                      valid={isValid(`relations.${question.name}`)}
                      registration={register(`relations.${question.name}`)}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CommercialCatastropheContractorRelations;
